export const FIRST_FRAME_LOAD = 'FIRST_FRAME_LOAD';
export const LOG_OUT = 'LOG_OUT';
export const GET_CONFIG = 'GET_CONFIG';



// WEBPACK FOOTER //
// ./src/app/stores/config/config-constants.js